<script lang="ts">
	import App from '../../App.svelte'
</script>

<!-- catch-all: every svelte5-router path (/maplibre, /login, …) must reach
     App.svelte — without this file SvelteKit 404s before the client router runs -->
<App />
